<div class="copy-to-clipboard" (click)="copy()" *transloco="let t">
    <fa-icon class="txt-success" icon="check" *ngIf="copyDone" @fadeText (@fadeText.done)="animationDone($event)"></fa-icon>
    <ng-content *ngIf="showIcon"></ng-content>
    <ng-container *ngIf="!customIcon">
        <fa-icon class="primary" icon="copy" *ngIf="showIcon"></fa-icon>
    <span class="primary copy-label ms-2" *ngIf="label">{{ label }}</span>
    </ng-container>
</div>
